import { isProduction } from "fe-common/utils/envGetter";
import { getIdToken } from "@kahunmedical/user-management";
import {
  SendMessageParams,
  SupportedCommunicationPlatforms,
} from "fe-common/commonTypes/communicationLambdaApi";

const COMMUNICATION_SERVICE_PROD_ENDPOINT = "https://message.kahun.com";
const COMMUNICATION_SERVICE_DEV_ENDPOINT = "https://message-dev.kahun.com";

const LAMBDA_ENDPOINT =
  isProduction() && false // WORK AROUND AS WE GET CORS IN PROD - always use dev
    ? COMMUNICATION_SERVICE_PROD_ENDPOINT
    : COMMUNICATION_SERVICE_DEV_ENDPOINT;

export const sendMessageWithCommunicationService = async (
  clinicName: string,
  method: SupportedCommunicationPlatforms,
  sendMessageParams: SendMessageParams,
) => {
  return fetch(`${LAMBDA_ENDPOINT}/${clinicName}/${method}/send`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${await getIdToken()}`,
    },
    body: JSON.stringify(sendMessageParams || {}),
  });
};
